import { render, staticRenderFns } from "./Personalize.vue?vue&type=template&id=1d3ad4f0&scoped=true"
import script from "./Personalize.vue?vue&type=script&lang=ts"
export * from "./Personalize.vue?vue&type=script&lang=ts"
import style0 from "./Personalize.vue?vue&type=style&index=0&id=1d3ad4f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3ad4f0",
  null
  
)

export default component.exports